import styled from 'styled-components'

import { Row } from 'components/Lists'

export const TitleRow = styled(Row)`
	font-weight: 500;
`
